// 获取文案信息
/**
 * 获取文案信息
 * @param {*} language
 * @returns
 * 先调用commitid对应版本的文案信息，如果获取失败，则再尝试调用default默认版本的信息，最终还失败则返回空
 */
import merge from 'lodash/merge'
import cloneDeep from 'lodash/cloneDeep'
export function getI18nMessages(language = 'in_ID') {
  if (!process.client) {
    const { commitId = 'default' } = require('../../package.json')

    try {
      const i18nMessages = require(`../../i18n-messages/${commitId}/${language}.json`)
      const _outMessages = require(`../../i18n-messages/${commitId}/en_US.json`)
      const outMessages = cloneDeep(_outMessages)

      const currentStateMsg = i18nMessages || {}

      if (Object.keys(currentStateMsg).length) {
        currentStateMsg[language] = merge(
          outMessages['en_US'],
          currentStateMsg[language]
        )
        return currentStateMsg
      }
      return {}
    } catch (err) {
      // eslint-disable-next-line
      console.log('===i18npath', `${commitId} ${language}`, err)
    }

    return {}
  }

  return {}
}
